function getInitials(name) {
  const allInitials = name.split(' ').map(part => part[0]).join('').toUpperCase();
  if (allInitials.length === 1) {
    return allInitials[0];
  }
  return allInitials[0] + allInitials.slice(-1);
}

export { getInitials };
//# sourceMappingURL=initials.mjs.map
